import {createAsyncThunk} from "@reduxjs/toolkit";
import axios from "axios";
import { rolesCollection, itemsCollection } from 'src/constant/firestore'
import { firestore } from "../../config/firebaseConfig";
import 'firebase/auth';
import 'firebase/firestore';
import firebase from "firebase/app";

const auth = firebase.auth();
export const createUser = createAsyncThunk(
    'users/create',
    async ({ email, password, additionalInfo, role }, { rejectWithValue }) => {
        console.log(additionalInfo, role)
        try {
            // Création de l'utilisateur avec Firebase Authentication
            const userCredential = await auth.createUserWithEmailAndPassword(email, password);
            const { uid } = userCredential.user;

            // Stockage des informations supplémentaires de l'utilisateur dans Firestore
            await firestore.collection('users').doc(uid).set(additionalInfo);

            // Spécification du rôle de l'utilisateur dans Firestore
            await rolesCollection.doc(uid).set({ ...role });

            // L'utilisateur a été créé avec succès
            return uid;
        } catch (error) {
            // Une erreur s'est produite lors de la création de l'utilisateur
            return rejectWithValue(error);
        }

    }
)

export const updateUser = createAsyncThunk(
    'users/update',
    async ({ data, resolve }) => {
        const handleResolve = (type) => {
            resolve && resolve(type);
        };

        try {
            await firestore.runTransaction(async (transaction) => {
                const userDocRef = firestore.collection('users').doc(data.id);
                const roleDocRef = firestore.collection('roles').doc(data.id);

                const userDoc = await transaction.get(userDocRef);
                const roleDoc = await transaction.get(roleDocRef);

                if (userDoc.exists && roleDoc.exists) {
                    transaction.update(userDocRef, data.userData);
                    transaction.update(roleDocRef, data.roleRights);
                }
            });

            handleResolve("fulfilled");
        } catch (error) {
            console.error('Erreur lors de la mise à jour des données de l\'utilisateur :', error);
            handleResolve("failed");
        }
    }
);


export const updateUserAuthData = createAsyncThunk(
    'users/update/auth_data',
    async ({data, resolve}) => {

        /**
         *
         * @param type {"fulfilled" | "failed"}
         */
        const handleResolve = (type) => {
            resolve && resolve(type)
        }

        try {
            await axios.put(`https://backend-api-zeta.vercel.app/api/user/${data.id}`, data)
            handleResolve("fulfilled")
        } catch (e) {
            handleResolve("failed")

        }

    }
)

export const updateUserRights = createAsyncThunk(
    'users/update/rights',
    async ({ id, data, resolve }) => {
        const handleResolve = (type) => {
            resolve && resolve(type);
        };

        try {
            // Mise à jour des droits de l'utilisateur dans la collection "roles"
            await rolesCollection.doc(id).update(data);
            handleResolve("fulfilled");
        } catch (error) {
            console.error('Erreur lors de la mise à jour des droits de l\'utilisateur :', error);
            handleResolve("failed");
        }
    }
);


export const deleteUser = createAsyncThunk(
    'users/delete',
    async ({ id, resolve }) => {
        const handleResolve = (type) => {
            resolve && resolve(type);
        };

        try {
            // Delete user from Firestore
            await firestore.collection('users').doc(id).delete();
            handleResolve("fulfilled");
        } catch (e) {
            handleResolve("failed");
        }
    }
);

export const fetchUser = createAsyncThunk(
    'users/fetch',
    async ({ resolve }) => {
        const handleResolve = (type, data) => {
            resolve && resolve(type, data);
        };

        try {
            const querySnapshot = await firestore.collection('users').get();
            const data = querySnapshot.docs.map((doc) => doc.data());
            handleResolve("fulfilled", data);
        } catch (e) {
            handleResolve("failed", []);
        }
    }
);

export const fetchRight = createAsyncThunk(
    'users/fetch',
    async ({userid, resolve}) => {

        /**
         *
         * @param type {"fulfilled" | "failed"}
         * @param data {[]}
         */
        const handleResolve = (type, data) => {
            resolve && resolve(type, data)
        }

        try {
            const docRef = rolesCollection.doc(userid).get();
             
        } catch (e) {
            handleResolve("failed", [])
        }

    }
)